import React from 'react';
import {
  FDBox,
  FDStack,
} from '@facet-wealth/design';
import {
  EstatePlanningC2BHeader,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/components/EstatePlanningC2BHeader';
import PropTypes from 'prop-types';

const EstatePlanningC2BWrapper = ({ children }) => {
  return (
    <FDBox padding={'400'}>
      <FDStack direction={'column'} spacing={2}>
        <EstatePlanningC2BHeader />
        {children}
      </FDStack>
    </FDBox>
  );
};

EstatePlanningC2BWrapper.defaultProps = {
  children: undefined,
};

EstatePlanningC2BWrapper.propTypes = {
  children: PropTypes.node,
};

export { EstatePlanningC2BWrapper };
